<div class="jobcard-label" *ngIf="label" [ngStyle]="{color: labelColor ? labelColor : '', 'opacity': disabled ? '0.5' : '1'}">{{ label }}</div>
<div class="p-inputgroup" [ngStyle]="{'opacity': disabled ? '0.5' : '1'}">
    <span *ngIf="icon" class="input-icon">
    <daz-icon [color]="required && !value ? '#df2323' : iconColor" [name]="icon"
              [size]="'20px'"></daz-icon>
    </span>
    <p-calendar
            #calendarRef
            (onSelect)="handleDateChange($event)"
            (onMonthChange)="handleMonthChange($event)"
            [(ngModel)]="value"
            [dateFormat]="dateFormat"
            [disabled]="disabled"
            [maxDate]="maxDate"
            [minDate]="minDate"
            [required]="required"
            [ngClass]="{'hub-calendar-icon' : icon, 'invalid': required && !value}"
            [placeholder]="placeholder"
            [readonlyInput]="true"
            [showTime]="showTime"
            [timeOnly]="timeOnly"
            [hourFormat]="'12'"
            [stepMinute]="stepMinute"
            class="hub-calendar"
            [disabledDates]="disabledDates"
            [showOtherMonths]="showOtherMonths"
    >
    </p-calendar>
</div>
